import { useState } from "react";

export const faqs = [
  {
    question: "Peut-on motoriser un volet roulant manuel existant ?",
    answer: "Oui, dans la plupart des cas. Nos techniciens vérifient d'abord la compatibilité de votre volet : coulisses, embouts, axe et espace dans le coffre. Si le volet est en bon état et que les dimensions le permettent, nous installons un moteur tubulaire Somfy directement dans l'axe sans modifier la baie. L'intervention dure généralement une à deux heures par volet. Si le tablier est trop usé ou si le coffre est trop petit, nous vous proposons une solution adaptée.",
  },
  {
    question: "Quel est le délai pour une motorisation Somfy ?",
    answer: "Nous intervenons sous 24 à 48 heures après votre demande dans Strasbourg et le Bas-Rhin. La visite technique dure environ 30 minutes : nous mesurons, analysons le type de volet et vous proposons le moteur adapté. L'installation proprement dite se fait en une à deux heures par volet. Vous disposez d'un volet motorisé et fonctionnel le jour même. Pour les projets de plusieurs volets, nous planifions l'intervention en une seule journée.",
  },
  {
    question: "Somfy est-il fiable pour la motorisation de volet ?",
    answer: "Somfy est le leader mondial de la motorisation de volets roulants et bénéficie d'une excellente réputation de fiabilité. Les moteurs Somfy sont conçus pour durer plusieurs milliers de cycles et sont garantis par le constructeur. Nous posons les moteurs adaptés au poids de votre tablier, ce qui prévient l'usure prématurée. En cas de problème, le réseau de pièces détachées Somfy est très dense et nous intervenons rapidement pour le remplacement. Le système io-homecontrol offre en plus un retour d'état en temps réel.",
  },
  {
    question: "Le devis pour une motorisation est-il gratuit ?",
    answer: "Oui, le devis est entièrement gratuit et sans engagement. Nos techniciens se déplacent à votre domicile pour analyser votre installation, mesurer les volets et vous proposer une solution personnalisée. Le devis détaillé inclut le choix du moteur, les points de commande, la main d'œuvre et la mise en service. Vous avez le temps de réfléchir : aucun paiement n'est demandé avant le début des travaux. Contactez-nous au 03 74 47 32 40 pour planifier votre visite.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-10 md:mb-14">
          Questions fréquentes sur la motorisation Somfy
        </h2>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-brand-border rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left hover:bg-brand-light/50 transition-colors"
              >
                <span className="text-brand-blue text-base font-semibold">{faq.question}</span>
                <span className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-brand-cyan/10">
                  <i className={`ri-${openIndex === index ? "subtract" : "add"}-line text-brand-cyan text-lg`}></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5 md:px-6 md:pb-6">
                  <p className="text-brand-text text-sm md:text-base leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}